import { Show } from "solid-js";
import type { CourtSummary } from "@saquei/types";
import { Button, Card, Chip } from "../ui";
import type { ChipTone } from "../ui";

interface Props {
    court: CourtSummary;
    onCheckIn: () => void;
    onCheckOut: () => void;
    onExtend: () => void;
    onDenounce: () => void;
}

const STATE_TONE: Record<string, ChipTone> = {
    livre: "livre",
    livre_aguardando: "aguardando",
    aguardando: "aguardando",
    ocupada: "ocupada",
    ocupada_expirando: "danger",
    ocupada_expirada: "danger",
    indisponivel: "neutral",
};

const STATE_LABEL: Record<string, string> = {
    livre: "livre",
    livre_aguardando: "reservada",
    aguardando: "reservada",
    ocupada: "ocupada",
    ocupada_expirando: "expirando",
    ocupada_expirada: "expirada",
    indisponivel: "indisponível",
};

export function CourtCard(props: Props) {
    const tone = () => STATE_TONE[props.court.state] ?? "neutral";
    const label = () => STATE_LABEL[props.court.state] ?? props.court.state;
    const canCheckIn = () =>
        props.court.state === "livre" || props.court.state === "livre_aguardando";
    const hasSession = () => Boolean(props.court.active_session_id);

    return (
        <Card class="dev-court-card">
            <header class="dev-court-card-head">
                <div class="dev-court-id">
                    <span class="code">{props.court.short_code.toUpperCase()}</span>
                    <strong>{props.court.name}</strong>
                </div>
                <Chip tone={tone()} size="md">{label()}</Chip>
            </header>

            <div class="dev-court-actions">
                <Button size="sm" variant="primary" onClick={props.onCheckIn} disabled={!canCheckIn()}>
                    Check-in
                </Button>
                <Button size="sm" variant="secondary" onClick={props.onCheckOut} disabled={!hasSession()}>
                    Encerrar
                </Button>
                <Button size="sm" variant="ghost" onClick={props.onExtend} disabled={!hasSession()}>
                    Estender +30
                </Button>
                <Button size="sm" variant="destructive" onClick={props.onDenounce}
                        disabled={props.court.state !== "ocupada_expirada"}>
                    Denunciar
                </Button>
            </div>

            <Show when={props.court.session_started_at}>
                <p class="dev-court-meta">
                    sessão iniciada <code>{fmtTimestamp(props.court.session_started_at!)}</code>
                    <Show when={props.court.session_expected_end_at}>
                        {" · termina "}<code>{fmtTimestamp(props.court.session_expected_end_at!)}</code>
                    </Show>
                </p>
            </Show>

            <Show when={props.court.invited_queue_id}>
                <p class="dev-court-meta dev-court-invited">
                    convidando até <code>{fmtTimestamp(props.court.invite_expires_at)}</code>
                </p>
            </Show>
        </Card>
    );
}

function fmtTimestamp(iso: string | null): string {
    if (!iso) return "—";
    return new Date(iso).toLocaleTimeString("pt-BR", { hour: "2-digit", minute: "2-digit", second: "2-digit" });
}
